import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.css'
  ]
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /Users/morne/Documents/dev/remindworks-docs/src/app/app.component.ts